import PropTypes from 'prop-types';

/** Components */
import Box from '@mui/material/Box';

const CustomTabPanel = ({ value, index, children, label = 'category' }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${label}-tabpanel-${index}`}
      aria-labelledby={`${label}-tab-${index}`}
    >
      <Box sx={{ pt: 2 }}>{children}</Box>
    </div>
  );
};

CustomTabPanel.propTypes = {
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
};

export default CustomTabPanel;
